import React, { useEffect } from 'react';

import BannersAero from './BannersAero';
import IncrementCounter from './IncrementCounter';
//  import Testimonials from './Testimonials';
import Ithiringbanner from './Ithiringbanner';
import Mechanicalhiringbanner from './Mechanicalhiringbanner';
import Itrequestform from './Itrequestform';
import Itjobapplypage from './Itjobapplypage';


const Ithiringpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <Ithiringbanner />
      <Itjobapplypage />
      {/* <Itrequestform  /> */}
      <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style>
    </div>
  )
}

export default Ithiringpage;